import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "s3-file",
  template: `<div>
    <img [class]="class" [style]="style" [src]="src" [alt]="alt" />
    <p
      style="margin-left:8px;margin-right:8px;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;"
    >
      {{ msg }}
    </p>
    <button (click)="downloadFile()" mat-raised-button class="bg-primary">
      <mat-icon>cloud_download</mat-icon>
    </button>
  </div>`,
})
export class S3File implements OnInit, AfterViewInit {
  @Input() src: string;
  @Input() alt = "";
  @Input() class = "";
  @Input() style = "";
  copySrc: string = "";
  @Input() msg = "";
  link = "";

  constructor(private http: HttpClient) {}
  ngOnInit(): void {
    this.copySrc = this.src;
    this.src = "/assets/images/doc.png";
  }

  ngAfterViewInit(): void {
    this.msg = this.copySrc.split("=")[this.copySrc.split("=").length - 1];
    const headers = new HttpHeaders({
      "X-access-token": localStorage.getItem("acc_tok"),
    });
    this.http
      .get(this.copySrc + "&type=link", { headers })
      .subscribe((val: any) => {
        this.link = val.link;
      });
  }

  downloadFile() {
    window.open(this.link, "_blank");
  }
}
